"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RSAPublicKey = void 0;
const ciphers_1 = require("../../crypto/ciphers");
const HashedObject_1 = require("../model/HashedObject");
const RSAKeyPair_1 = require("./RSAKeyPair");
class RSAPublicKey extends HashedObject_1.HashedObject {
    constructor() {
        super();
    }
    static fromKeys(publicKey) {
        let pk = new RSAPublicKey();
        pk.publicKey = publicKey;
        pk.init();
        return pk;
    }
    init() {
        this._rsaPromise = this.initRSA();
    }
    async initRSA() {
        const _rsa = new ciphers_1.RSADefaults.impl();
        await _rsa.loadKeyPair(this.getPublicKey());
        return _rsa;
    }
    async validate() {
        // TODO: self sign??
        return true;
    }
    getClassName() {
        return RSAPublicKey.className;
    }
    getPublicKey() {
        return this.publicKey;
    }
    getKeyPairHash() {
        return RSAKeyPair_1.RSAKeyPair.hashPublicKeyPart(this.publicKey);
    }
    async verifySignature(text, signature) {
        if (this._rsaPromise === undefined) {
            throw new Error('RSA public key is empty, cannot verify signature');
        }
        return (await this._rsaPromise).verify(text, signature);
    }
    async encrypt(plainText) {
        if (this._rsaPromise === undefined) {
            throw new Error('RSA public key is empty, cannot encrypt');
        }
        return (await this._rsaPromise).encrypt(plainText);
    }
}
exports.RSAPublicKey = RSAPublicKey;
RSAPublicKey.className = 'hhs/v0/RSAPublicKey';
HashedObject_1.HashedObject.registerClass(RSAPublicKey.className, RSAPublicKey);
//# sourceMappingURL=RSAPublicKey.js.map